const customAddToCart = {
    init() {

        //Update cart on QTY change
        let timeout;
        $('.woocommerce').on( 'change', 'select.qty', function(){
            if ( timeout !== undefined ) {
                clearTimeout( timeout );
            }
            timeout = setTimeout(function() {
                $("[name='update_cart']").trigger("click"); // trigger cart update
            }, 1000 ); // 1 second delay, half a second (500) seems comfortable too
        });

        $( document ).on( 'click', '.single_add_to_cart_button', function(e) {
            e.preventDefault();
            var $thisbutton = $(this),
                $form = $thisbutton.closest('form.cart'),
                id = $thisbutton.val(),
                product_qty = $form.find('select.qty').val() || 1,
                product_id = $form.find('input[name=product_id]').val() || id,
                variation_id = $form.find('input[name=variation_id]').val() || 0;

            var data = {
                action: 'woocommerce_ajax_add_to_cart',
                product_id: product_id,
                product_sku: '',
                quantity: product_qty,
                variation_id: variation_id,
            };

            $(document.body).trigger('adding_to_cart', [$thisbutton, data]);
            $.ajax({
                type: 'post',
                url: wc_add_to_cart_params.ajax_url,
                data: data,
                beforeSend: function (response) {
                    $thisbutton.removeClass('added').addClass('loading');
                },
                complete: function (response) {
                    $thisbutton.addClass('added').removeClass('loading');
                },
                success: function (response) {

                    if (response.error && response.product_url) {
                        window.location = response.product_url;
                        return;
                    } else {
                        $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $thisbutton]);
                        console.log(response);
                        var mini_cart_total = response.fragments['span.mini-cart__total-value']

                        $('.mini-cart__menu-total span').html(mini_cart_total);

                        setTimeout(function(){
                            $('.mini-cart__item-wrapper').trigger('click');
                        }, 2000)
                    }
                },
            });

            return false;
        });
    }
}
export {customAddToCart}